import React from "react";
import {postFaveWatch, postFaveRead, postFaveLearn, getAllFaves} from "../../Features/Favourites/faveSlice";
import {useSelector, useDispatch} from "react-redux";

const FaveHeart = React.memo((props) => {

    const dispatch = useDispatch();

    const { customStyles, type, mediaId, mediaType, fadeFunction } = props
    const { faveWatches, faveReads, faveLearns } = useSelector((state) => state.fave)


    let listOfFaves = [];

    if (faveWatches) {
        listOfFaves = faveWatches;
    }

    if (faveReads) {
        listOfFaves = [...listOfFaves, ...faveReads];
    }

    if (faveLearns) {
        listOfFaves = [...listOfFaves, ...faveLearns];
    }

    const mediaData = {
        mediaId, mediaType
    }

    const heartFilLStyle = (listOfFaves && listOfFaves.length && listOfFaves.includes(mediaId?.toString()) ? " ri-heart-2-fill " : " ri-heart-2-line ")

    let styles = customStyles || " text-xl text-pink-icon flex justify-end  cursor-pointer "

    if(type && type === "Watch"){
        styles = " text-xl text-pink-icon flex w-8 h-8 rounded-lg justify-center items-center bg-purple-slumber row-start-2 row-end-3 col-start-21 col-end-22 sm:col-start-20 sm:col-end-21  cursor-pointer "
    }

    if(type && type === "watches"){
        styles = " text-xl text-pink-icon flex w-8 h-8 rounded-lg justify-center items-center bg-purple-slumber row-start-2 row-end-3 col-start-21 col-end-22 sm:col-start-20 sm:col-end-21  cursor-pointer "
    }

    if(type && type ==="Learn"){
        styles = " text-xl text-pink-icon flex w-8 h-8 rounded-lg justify-center items-center bg-purple-slumber row-start-2 row-end-3 col-start-22 col-end-23  cursor-pointer "
    }

    const handleClick = async (e) => {
        e.stopPropagation()
        await fadeFunction?.();
        switch (type) {
            case "Watch":
            case "watches":
            case "Watch_offCanvas":
            case "NewWatch":
                dispatchAndRefresh(postFaveWatch);
                break;

            case "Read":
            case "reads":
            case "Read_offCanvas":
            case "NewRead":
                dispatchAndRefresh(postFaveRead);
                break;

            case "Learn":
            case "Learn_offCanvas":
            case "NewLearn":
                dispatchAndRefresh(postFaveLearn);
                break;

            default:
                break;
        }
    };

    const dispatchAndRefresh = async (dispatchFunction) => {
        await dispatch(dispatchFunction(mediaData));
        dispatch(getAllFaves());
    };

    return (
        <i onClick={handleClick} className={` ${heartFilLStyle} ${styles}`} />
    );
});

export default FaveHeart;
